// extracted by mini-css-extract-plugin
module.exports = {"hdr-Icon":"Icon_hdr-Icon__KJAoi","hdr-Icon--isBig":"Icon_hdr-Icon--isBig__nDZPe"};